// extracted by mini-css-extract-plugin
module.exports = {"container":"questionToopltip_container__3_fjT","text":"questionToopltip_text__2FeUd"};